module.exports = __webpack_public_path__ + "assets/img/icon-ccb50504.png";